export default __webpack_public_path__ + "static/media/obaleye.af549552.png";